import React, { FC } from "react";
import Activities from "./Activities";

const FactoryActivitiesPage: FC = () => {
  return <Activities />;
};

export default FactoryActivitiesPage;
